import React from 'react'
import { useSelector } from 'react-redux';
import { SUBSCRIPTION_MODULE_TYPE } from '../../constants';

export default function PaymentSteps({ selectedStep }) {
    const { stripePlans } = useSelector((state) => state.stripe);

    return (
        <div className="row indicatorSectionMain">
            <div className="col-4 p-0 indicatorSection">
                <div className="indicatorCircelLine indicatorCircelLineLeft">
                    {selectedStep >= 2 ? <img src="assets/img/steptick.svg" alt="" srcset="" /> : <div className="Iconcircle IconcircleActive"></div>
                    }
                    <div className={`ConnectLineLeft ${selectedStep >= 2 ? 'ConnectLineActive' : ""}`}></div>
                </div>
                <p className="indicatorSectiondiv indicatorSectiondivActive">
                    {(stripePlans?.planType?.value === SUBSCRIPTION_MODULE_TYPE.FUNDS || stripePlans?.planType?.value === SUBSCRIPTION_MODULE_TYPE.COMPANYFUNDS) ? "Add funds" : (stripePlans?.planType?.value === SUBSCRIPTION_MODULE_TYPE.CUSTOM || stripePlans?.planType?.value === SUBSCRIPTION_MODULE_TYPE.PAIDUPCAPITAL) ? "Select amount" : "Select quantity"}
                </p>
            </div>
            <div className="col-4 p-0 indicatorSection">
                <div className="indicatorCircelLine indicatorCircelLineCenter">
                    <div className={`ConnectLineLeft ${selectedStep >= 2 ? 'ConnectLineActive' : ""}`}></div>
                    {selectedStep >= 3 ? <img src="assets/img/steptick.svg" alt="" srcset="" /> : <div className={`Iconcircle ${selectedStep >= 2 ? 'IconcircleActive' : ""}`}></div>}
                    <div className={`ConnectLineLeft ${selectedStep >= 3 ? 'ConnectLineActive' : ""}`}></div>
                </div>
                <p className="indicatorSectiondiv">Select payment method</p>
            </div>
            <div className="col-4 p-0 indicatorSection">
                <div className="indicatorCircelLine indicatorCircelLineRight">
                    <div className={`ConnectLineLeft ${selectedStep >= 3 ? 'ConnectLineActive' : ""}`}></div>
                    {selectedStep >= 4 ? <img src="assets/img/steptick.svg" alt="" srcset="" /> : <div className={`Iconcircle ${selectedStep >= 3 ? 'IconcircleActive' : ""}`}></div>}
                </div>
                <p className="indicatorSectiondiv">Pay</p>
            </div>
        </div>
    )
}
